import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const STAFF_API = `${BACKEND_URL}/api/staff`;
const STAFF_KEY = "af_staff_token";

export function getStaffToken() {
  return localStorage.getItem(STAFF_KEY);
}
export function setStaffToken(t) {
  if (t) localStorage.setItem(STAFF_KEY, t);
  else localStorage.removeItem(STAFF_KEY);
}

export const staffApi = axios.create({ baseURL: STAFF_API });
staffApi.interceptors.request.use((config) => {
  const t = getStaffToken();
  if (t) config.headers["x-staff-token"] = t;
  return config;
});

export function formatErr(detail) {
  if (detail == null) return "Ocurrió un error. Intenta de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const staffLogin = (email, password) =>
  axios.post(`${STAFF_API}/auth/login`, { email, password }).then((r) => r.data);
export const staffVerify2FA = (email, password, code) =>
  axios.post(`${STAFF_API}/auth/2fa/verify`, { email, password, code }).then((r) => r.data);
export const staffMe = () => staffApi.get(`/auth/me`).then((r) => r.data.user);
export const staffChangePassword = (current_password, new_password) =>
  staffApi.post(`/auth/change-password`, { current_password, new_password }).then((r) => r.data);
export const staffLogout = () => staffApi.post(`/auth/logout`).then((r) => r.data);

export const getBandeja = () => staffApi.get(`/asesor/bandeja`).then((r) => r.data);
export const getExpediente = (id) => staffApi.get(`/tramites/${id}`).then((r) => r.data.expediente);
export const revisarDocumento = (id, doc, decision, motivo) =>
  staffApi.post(`/tramites/${id}/documentos/${doc}/revision`, { decision, motivo }).then((r) => r.data);
export const cambiarEtapa = (id, id_etapa, nota) =>
  staffApi.post(`/tramites/${id}/etapa`, { id_etapa, nota }).then((r) => r.data);
export const addActividad = (id, nota) =>
  staffApi.post(`/tramites/${id}/actividades`, { nota }).then((r) => r.data);
export const crearPropuesta = (id, payload) =>
  staffApi.post(`/tramites/${id}/propuestas`, payload).then((r) => r.data);
export const listarPropuestas = (id) =>
  staffApi.get(`/tramites/${id}/propuestas`).then((r) => r.data.propuestas);
export const getStaffNotificaciones = () => staffApi.get(`/notificaciones`).then((r) => r.data.items);
export const getDashboardKpis = () => staffApi.get(`/dashboard/kpis`).then((r) => r.data);

export async function fetchStaffDocBlob(id, doc) {
  const t = getStaffToken();
  const resp = await axios.get(`${STAFF_API}/tramites/${id}/documentos/${doc}/file`, {
    headers: { "x-staff-token": t },
    responseType: "blob",
  });
  return URL.createObjectURL(resp.data);
}

// Admin (gated; reachable solo con 2FA habilitado)
export const adminUsuarios = () => staffApi.get(`/admin/usuarios`).then((r) => r.data.usuarios);
export const adminCrearUsuario = (p) => staffApi.post(`/admin/usuarios`, p).then((r) => r.data);
export const adminActualizarUsuario = (uid, p) => staffApi.patch(`/admin/usuarios/${uid}`, p).then((r) => r.data);
export const adminAsignacion = () => staffApi.get(`/admin/asignacion`).then((r) => r.data.tramites);
export const adminAsignar = (tramite_id, asesor_id) =>
  staffApi.post(`/admin/asignar`, { tramite_id, asesor_id }).then((r) => r.data);
export const adminVehiculos = () => staffApi.get(`/admin/vehiculos`).then((r) => r.data.vehiculos);
export const adminUpsertVehiculo = (v) => staffApi.post(`/admin/vehiculos`, v).then((r) => r.data);
export const adminVehiculosConfig = () => staffApi.get(`/admin/vehiculos/config`).then((r) => r.data);
export const adminSetVehiculosConfig = (modo, cantidad) =>
  staffApi.post(`/admin/vehiculos/config`, { modo, cantidad }).then((r) => r.data);
export const adminImportVehiculos = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return staffApi.post(`/admin/vehiculos/import`, fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
};
export const adminParametros = () => staffApi.get(`/admin/parametros`).then((r) => r.data.parametros);
export const adminSetParametro = (id_parametro, valor) =>
  staffApi.post(`/admin/parametros`, { id_parametro, valor }).then((r) => r.data);
export const adminAuditoria = () => staffApi.get(`/admin/auditoria`).then((r) => r.data.items);
